/* HM 26/09/2026 - Audit complet du 25/09 : « aucun mot ne doit tomber seul en fin de ligne ».
   Colle le dernier mot de chaque bloc de texte au precedent par une espace insecable.
   Le texte ne change pas (seule une espace devient insecable). Garde-fous : blocs d'au moins 3 mots,
   deux derniers mots de 28 caracteres maximum, jamais dans les champs de saisie, le code ou les SVG. */
(function(){
  var BLOCS='p,h1,h2,h3,h4,h5,h6,li,summary,figcaption,blockquote,dt,dd,label,button,a,td,th,small';
  var EXCLU='input,textarea,select,script,style,code,pre,svg,[contenteditable],[data-hm-sans-insecable]';
  function traiter(el){
    if(!el||el.closest(EXCLU)) return;
    /* 26/09 : jamais sur un bloc qui contient d'autres blocs (liste, paragraphes) : l'espace de mise en page entre deux elements devenait visible (menu, « Mastering » decale) */
    if(el.querySelector('p,li,ul,ol,div,section,article,h1,h2,h3,h4,h5,h6,br,table,dl,figure')) return;
    var txt=el.textContent||'';
    if(txt.trim().split(/\s+/).length<3) return;
    var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null), nodes=[], n;
    while((n=w.nextNode())){ if(!n.parentElement.closest(EXCLU)) nodes.push(n); }
    var fin=0, mot=0;
    for(var i=nodes.length-1;i>=0;i--){
      var s=nodes[i].nodeValue, j=s.length-1;
      if(fin===0){ while(j>=0&&/\s/.test(s[j]))j--; if(j<0)continue; fin=1; }
      while(j>=0&&!/\s/.test(s[j])){ j--; mot++; }
      if(j>=0){
        /* deja colle (insecable) : rien a faire, le script peut repasser sans rien empiler */
        if(s[j]!==' '||mot>18) return;
        if(!s.slice(0,j).trim()) return; /* l'espace est seule dans son noeud : c'est de la mise en page, pas une espace entre deux mots */
        var k=j-1, avant=0, m=i, t=s;
        while(true){ while(k>=0&&!/\s/.test(t[k])){k--;avant++;} if(k>=0||m===0)break; m--; t=nodes[m].nodeValue; k=t.length-1; }
        if(avant+mot>28) return;
        nodes[i].nodeValue=s.slice(0,j)+' '+s.slice(j+1);
        return;
      }
    }
  }
  function passer(racine){ var l=(racine.querySelectorAll?racine.querySelectorAll(BLOCS):[]); for(var i=0;i<l.length;i++) traiter(l[i]); if(racine.matches&&racine.matches(BLOCS)) traiter(racine); }
  function tout(){ passer(document.body); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',tout); else tout();
  window.addEventListener('load',function(){ tout(); setTimeout(tout,2000); });
  if(window.MutationObserver){
    var file=[], minuteur=null;
    new MutationObserver(function(ms){ for(var i=0;i<ms.length;i++){ var a=ms[i].addedNodes; for(var j=0;j<a.length;j++) if(a[j].nodeType===1) file.push(a[j]); }
      if(file.length&&!minuteur) minuteur=setTimeout(function(){ var f=file; file=[]; minuteur=null; for(var i=0;i<f.length;i++) if(f[i].isConnected) passer(f[i]); },120);
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
})();
